import Cookies from "js-cookie";

// used in nextjs, client side

import getTokenCookieName from "bwax/query/getTokenCookieNameNext";

export default async function setTokenCookie(sessionToken) {

    const expires = 100;
    const sessionTokenName = await getTokenCookieName();
    
    Cookies.set(sessionTokenName, sessionToken, { expires });

}

export async function removeTokenCookie() {
    const sessionTokenName = await getTokenCookieName();
    
    Cookies.remove(sessionTokenName);
}


